<template>
    <div>
        <p
            class="title is-7"
        >{{ "components.common.quick-login-reg.registration.step" | translate }} 2/2</p>
        <p
            class="title is-7"
        >{{ "components.common.quick-login-reg.registration.step 2 title" | translate }}</p>
        <p
            class="subtitle is-7"
        >{{ "components.common.quick-login-reg.registration.step 2 message" | translate }}</p>

        <form @submit.prevent="submit()" :class="{ 'is-loading': loading }" role="form">
            <div class="field has-addons">
                <div class="control">
                    <input
                        v-model.trim="code"
                        v-validate="'required|digits:4'"
                        data-vv-name="confirmation code"
                        data-vv-validate-on="change"
                        :placeholder="'components.common.quick-login-reg.registration.confirmation code' | translate"
                        class="input is-small"
                        maxlength="4"
                        typeof="text"
                        ref="code"
                    />
                    <p
                        class="help is-danger"
                        v-if="errors.has('confirmation code:digits') || confirmationCodeError"
                    >{{"components.common.quick-login-reg.registration.validation.confirmation code error" | translate}}</p>
                </div>
                <div class="control">
                    <a class="button is-static is-small">{{countdown}}</a>
                </div>
            </div>
            <button
                class="card-footer-item button is-warning is-small is-fullwidth"
                :class="{ 'is-loading': loading }"
            >
                <span>{{ "components.common.quick-login-reg.registration.register" | translate }}</span>
            </button>
        </form>
    </div>
</template>

<script>
import Vue from 'vue';

import registrationService from '../../../../../_common/services/registration.service';
import ymService from '../../../../../_common/services/ym.service';
import gaService from '../../../../../_common/services/ga.service';
import utils from '../../../../../_common/utils';

export default {
    name: 'quick-login-reg-registration-by-email-confirmation',
    $_veeValidate: { validator: 'new' },
    data: () => ({
        regData: null,
        code: null,
        loading: false,
        timeoutStart: new Date(),
        timeout: 15 * 60 * 1000, // 15 min
        countdown: null,
        countdownTimer: null,
        confirmationCodeError: null
    }),
    computed: {
        hasRegistrationError() {
            return false;
        }
    },
    mounted() {
        this.$refs.code.focus();
        this.startCountdown();
    },
    methods: {
        resetFields() {
            this.code = null;
        },
        setRegData(regData) {
            this.regData = regData;
            this.startCountdown();
        },
        async submit() {
            await this.$validator.validateAll();
            if (this.errors.any() || this.loading) return;

            this.errors.clear();
            this.confirmationCodeError = false;
            this.loading = true;
            try {
                const result = await registrationService.confirmEmail({
                    ...this.regData,
                    code: this.code
                });
                await Vue.state.player.reload();
                Vue.state.lang.ensureLocalLangOrPlayer(Vue.state.player.get().lang || 'ru');
                ymService.send('reachGoal', 'REGISTRATION SUCCESS');
                gaService.send('registration', 'registrationsuccess', 'registration3');
                await Vue.router.teleport.afterRegistration();
            } catch (ex) {
                console.error(ex);
                this.confirmationCodeError = true;
            }

            this.loading = false;
        },
        startCountdown() {
            this.countdownTimer && clearInterval(this.countdownTimer);
            this.timeoutStart = new Date();
            this.setCountdown();
            this.countdownTimer = setInterval(() => {
                this.setCountdown();
            }, 1000);
        },
        setCountdown() {
            let diff = this.timeoutStart.valueOf() - new Date().valueOf() + 15 * 60 * 1000;
            diff = Math.max(diff, 0);
            this.countdown = utils.formatDateTime(diff, 'mm:ss');
        }
    },
    beforeDestroy() {
        this.resetFields();
        this.countdownTimer && clearInterval(this.countdownTimer);
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/quick-login-reg/registration-by-email-confirmation.vue